import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function getAllToSelectFailure(draft: Draft<IManufacturerData>) {
  draft.getAllToSelect.config.isLoading = false;
}

export default getAllToSelectFailure;
